import { ButtonProps } from '@atlaskit/button';
import { SelectableButton } from '@databases/atlaskit/SelectableButton';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

type TriggerButtonProps = ButtonProps & {
  isActive?: boolean;
};

const TriggerButton = forwardRef<HTMLDivElement, TriggerButtonProps>(
  function TriggerButton({ isActive, ...buttonProps }, ref) {
    return (
      <Container ref={ref}>
        <SelectableButton
          {...buttonProps}
          $isActive={isActive}
          $isSelected={buttonProps.isSelected}
          appearance="subtle"
        >
          {buttonProps.children}
        </SelectableButton>
      </Container>
    );
  }
);

export default TriggerButton;
